"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheUtilityEnvironmentProblem() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section id="the-utility-environment-problem" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4">
        <div ref={ref} className={`max-w-4xl mx-auto bg-accent text-accent-foreground p-8 md:p-12 lg:p-16 rounded-2xl shadow-xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default mb-8 tracking-tight">
            Why Do Utilities Use Evermark for Substation Identification?
          </h2>
          
          <div className="space-y-6 text-lg md:text-xl font-sans leading-relaxed opacity-90">
            <p>
              Substation and power-generation identification lives in the worst conditions a label can face — full sun, rain, ice, temperature swings, and decades in place. A printed label or a soft material fades, peels, or chalks, and an unreadable nameplate or warning sign on energized equipment is both an operations problem and a safety problem.
            </p>
            <p>
              Evermark Industrial Solutions produces this identification in engraved stainless steel and anodized aluminum, where the legend is part of the metal and stays readable for the life of the asset. Equipment nameplates, apparatus and circuit IDs, and high-voltage warning signs are engraved to the utility's format and built for the outdoor environment.
            </p>
            <p>
              Power-generation plants add their own identification load — transformer and switchgear nameplates, valve and pipe identification, and asset tags across the facility. Evermark engraves the full set from one source, in materials matched to each placement.
            </p>
          </div>
        </div>
      </div>
    </section>;
}